export enum AmenityCountType {
  Parking = 'PARKING',
  Bathroom = 'BATHROOM',
  Toilet = 'TOILET',
  AirDirection = 'AIR_DIRECTION',
}

export enum SizedAmenityType {
  Garden = 'GARDEN',
  Balcony = 'BALCONY',
  Warehouse = 'WAREHOUSE',
}

export interface IAmenityCountItem {
  type: AmenityCountType;
  count: number;
}

export interface ISizedAmenityItem {
  type: SizedAmenityType;
  sizes: number[];
}

export type SizedAmenityFormValueType = Record<Partial<SizedAmenityType>, number[]>;

export type SizedAmenityErrorsType = Record<SizedAmenityType, Record<number, string>>;
